import {Component, OnInit} from '@angular/core';
import {directus, Post} from "../../../../directus";
import {ActivatedRoute} from "@angular/router";
import {CommonModule} from "@angular/common";
import {readItem} from "@directus/sdk";
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-post',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './post.component.html',
  styleUrl: './post.component.css'
})
export class PostComponent implements OnInit{
  post: Post | undefined;
  baseUrl = environment.baseUrl;
  apiUrl = environment.apiUrl;
  constructor(private route: ActivatedRoute) {
  }
  ngOnInit(): void {
    const _slug = this.route.snapshot.paramMap.get('slug');
    this.getPostBySlug( ( _slug ? _slug : '/posts' ) );
  }

  async getPostBySlug(slug: string){
    //@ts-ignore
    this.post = await directus
      .request<Post>(readItem("posts", slug));
  }

}
